import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "instagram-highlight instagram-block"
}
const _hoisted_2 = { class: "instagram-highlight__media" }

import {
  computed, onMounted, ref, onBeforeUnmount, inject,
} from 'vue';
import UGCMediaSlider from './UGCMediaSlider.vue';
import InstagramTextContent from './InstagramTextContent.vue';
import { registerUGCMediaBlockKey, unregisterUGCMediaBlockKey } from '@/composables/useUGCMedia';
import useUGCMedia from '@/composables/useUGCMedia';

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'InstagramHighlight',
  props: {
  block: {
    type: Object,
    required: true,
  },
  product: {
    type: Object,
    default: null,
  },
},
  setup(__props) {

const props = __props



const fields = computed(() => props.block?.fields || {});
const tagline = computed(() => fields.value.Tagline);
const numberOfMedia = computed(() => fields.value.NumberOfMedia || 0);
const title = computed(() => fields.value.Title);
const text = computed(() => fields.value.Text);
const ugcSearchArgs = computed(() => {
  const args = fields.value.UGCSearchArgs;
  if (!args) return {};
  try {
    return JSON.parse(args);
  } catch (e) {
    return {};
  }
});

const isDesktop = ref(false);
let ugcMedia = null as any;
const registerUGCMediaBlock = inject(registerUGCMediaBlockKey, null);
const unregisterUGCMediaBlock = inject(unregisterUGCMediaBlockKey, null);

if (!registerUGCMediaBlock) {
  ugcMedia = useUGCMedia(ugcSearchArgs, numberOfMedia);
}

onMounted(() => {
  window.addEventListener('resize', updateIsDesktop);
  updateIsDesktop();
  
  registerUGCMediaBlock?.(props.block.systemId, {
    setMedia,
    numMedia: numberOfMedia.value || 0,
  });
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateIsDesktop);
  unregisterUGCMediaBlock?.(props.block.systemId);
});

const media = ref<any>([]);

function setMedia(parentProducts: [any]) {
  media.value = parentProducts;
}

function updateIsDesktop() {
  isDesktop.value = window.innerWidth < 1024;
}

const mediaWidthToHeightRatio = computed(() => (isDesktop.value ? 60 : 70));

const displayMedia = computed(() => ugcMedia ? ugcMedia.remainingMedia.value : media.value);


return (_ctx: any,_cache: any) => {
  return (_unref(displayMedia).length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(tagline) || _unref(title) || _unref(text))
          ? (_openBlock(), _createBlock(InstagramTextContent, {
              key: 0,
              tagline: _unref(tagline),
              title: _unref(title),
              text: _unref(text)
            }, null, 8, ["tagline", "title", "text"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(UGCMediaSlider, {
            items: _unref(displayMedia),
            "show-items": 1,
            "width-to-height-ratio": _unref(mediaWidthToHeightRatio)
          }, null, 8, ["items", "width-to-height-ratio"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})